import instance from '@/services/repository';

const resource = '/machineryeventtypes';

export default {
    getAll() {
        return instance.get<IMachineryEventType[]>(`${resource}`);
    },
    create(payload: any) {
        return instance.post<IMachineryEventType>(`${resource}`, payload);
    },
    update(payload: any) {
        return instance.put<IMachineryEventType>(`${resource}`, payload);
    },
    delete(id: string) {
        return instance.delete(`${resource}/${id}`);
    },
};
